module.exports = __webpack_public_path__ + "img/27.4.NH3-N.31eb03a5.png";